var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: { center: "", visible: _vm.dialogVisible, width: "35%" },
      on: {
        close: _vm.close,
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticStyle: { padding: "0 0.2rem" } },
        [
          _c("p", { staticClass: "p1" }, [_vm._v(_vm._s(_vm.title))]),
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": "70px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "登录手机", prop: "loginAccount" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "4rem" },
                    attrs: { placeholder: "请输入手机号" },
                    model: {
                      value: _vm.ruleForm.loginAccount,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "loginAccount", $$v)
                      },
                      expression: "ruleForm.loginAccount",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "登录名称", prop: "userName" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "4rem" },
                    attrs: {
                      placeholder:
                        "请输入用户名称/用户昵称 用户可登录后自行调整",
                    },
                    model: {
                      value: _vm.ruleForm.userName,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "userName", $$v)
                      },
                      expression: "ruleForm.userName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "邮箱地址", prop: "email" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "4rem" },
                    attrs: {
                      placeholder:
                        "请输入用户名称/用户昵称 用户可登录后自行调整",
                    },
                    model: {
                      value: _vm.ruleForm.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "email", $$v)
                      },
                      expression: "ruleForm.email",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "lineBox1" },
            [
              _c("p", { staticClass: "p3" }, [
                _vm._v(" 是否可使用公司账户进行订单支付 "),
              ]),
              _c("el-switch", {
                attrs: {
                  "active-color": "#617AEC",
                  "inactive-color": "#9E9E9E",
                },
                model: {
                  value: _vm.ruleForm.isPay,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "isPay", $$v)
                  },
                  expression: "ruleForm.isPay",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "lineBox1" },
            [
              _c("p", { staticClass: "p3" }, [
                _vm._v(" 是否是可接单的定制师 "),
              ]),
              _c("el-switch", {
                attrs: {
                  "active-color": "#617AEC",
                  "inactive-color": "#9E9E9E",
                },
                model: {
                  value: _vm.ruleForm.isReceivingOrders,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "isReceivingOrders", $$v)
                  },
                  expression: "ruleForm.isReceivingOrders",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          JSON.stringify(_vm.stateSw) !== "{}"
            ? _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.modifyStateClick },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.stateSw.keys == 1
                              ? "确认停用该用户"
                              : "确认恢复该用户"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.save("ruleForm")
                        },
                      },
                    },
                    [_vm._v("保 存")]
                  ),
                ],
                1
              ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }